/* eslint-disable react/prop-types */
import React from 'react';

import { SectionCard } from '../../ui';
import PowerSummary from '../../detail/components/powerSummary';
import TenantInsight from '../../detail/components/tenantInsight';

/**
 * 商家洞察（二级 tab）· 容器
 * ==================================================================
 * 内含两块卡片，自上而下：
 *   1. 商家洞察 —— 二期「商家服务情况汇总」，实现见 detail/components/tenantInsight；
 *   2. POWER总结 —— 原 POWER 三段的实现。
 *
 * 第 2 块内容与生成机制直接沿用旧「商家档案-概览」tab 的 POWER 总结，
 * 已抽成 detail/components/powerSummary（两边共用一份轮询，不再各写一套）。
 *
 * 2026-10-13：二期「商家服务情况汇总」的下游接口已由 litta-workwx 侧开出
 * （POST /athena/tenantServicePeriods、/athena/storeServiceSummary、
 * /athena/coachServiceSummary）。前端按 ①②③ 分步接入，当前仅完成
 * ① 观察期下拉（tenantInsight 组件），② ③ 待接。
 */
export const PowerPane = (props) => {
  const { tenantId } = props;
  return (
    <>
      {/* 二期商家洞察：当前只完成第 ① 步（观察期下拉，数据源 /athena/tenantServicePeriods），
          ② 店铺服务汇总 / ③ 教练服务明细 待接。 */}
      <SectionCard title="商家洞察">
        <TenantInsight tenantId={tenantId} />
      </SectionCard>

      <SectionCard
        title="POWER总结"
        subtitle="商家概况 / 服务情况 / 会员画像 三段接口生成的长文本，支持换行"
        tips=""
      >
        <PowerSummary tenantId={tenantId} />
      </SectionCard>
    </>
  );
};

export default PowerPane;
